import styled from "styled-components/macro"

export const TutorialWrap = styled.div`
  border-bottom: 1px solid #eee;
  padding: 15px 0;
`
